import React, {useState, useEffect} from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './userOrderTable.scss'
import { db } from '../../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore' 
import { Link } from 'react-router-dom'


const  UserSubscriptionTable = ({customerId}) => {

//   const [ rows, setRows ] = useState([])

  const [ subData, setSubData ] = useState([])

//   useEffect(() => {
    
//     //LISTEN REAL TIME
    
//         onSnapshot(collection(db, "order"), (snapShot) => {
//           let list = [];
//           snapShot.docs.forEach((doc) => {
//             list.push({ id: doc.id, ...doc.data()})
//           })
//           setRows(list)
//           // setIsLoading(false)
//           // console.log(data)
//         }, 
//           (error) => {
//             console.log(error)
//           }
//         ); 
     
//   },[])


useEffect(() => {
    
    //LISTEN REAL TIME

    const subQuery = async() => {

      const subRef = (collection(db, "subscribers"));
      const q = query(subRef, where("userId", "==", customerId));

      const querySnapshot = await getDocs(q);
        let list = []
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        list.push({id: doc.id, ...doc.data()})
        // console.log(doc.id, " => ", doc.data());
        console.log(list)

        setSubData(list)
        // console.log(subData)
      });

    }
    
    subQuery()   
  },[])

  
  const options = {  maximumFractionDigits: 2   }
 
  
  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow className="tableRow"> 
           
            <TableCell className='tableCell'>Subscription ID</TableCell>
            <TableCell className='tableCell'>Image</TableCell>
            <TableCell className='tableCell'>Outlet Name</TableCell>
            <TableCell className='tableCell'> Outlet</TableCell>
            <TableCell className='tableCell'>Region</TableCell>
            <TableCell className='tableCell'>Area</TableCell>
            <TableCell className='tableCell'>Date</TableCell>
            <TableCell className='tableCell'>Plan</TableCell>
            <TableCell className='tableCell'>Amount</TableCell>
            <TableCell className='tableCell'>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {subData.map((row) => (
            <TableRow key={row.id}  className="tableRow">
              
                <TableCell className='tableCell'><span>{row.subscriberID}</span></TableCell>
                <TableCell className='tableCell'>
                <div className='cellWrapper'>
                  <img src={row.files[0]} className='image' alt=''/>
                </div>
                </TableCell>
                <TableCell className='tableCell'>{row.outletname}</TableCell>
                <TableCell className='tableCell'>{row.outlet}</TableCell>
                <TableCell className='tableCell'>{row.region}</TableCell>
                <TableCell className='tableCell'>{row.area}</TableCell>
               <TableCell className='tableCell'>{row.timeStamp.toDate().toLocaleDateString()}</TableCell>
                <TableCell className='tableCell'>{row.subscriberPlan? row.subscriberPlan: "Unpaid"}</TableCell>
                <TableCell className='tableCell'>N{Intl.NumberFormat("en-US",options).format(row.amount)}.00</TableCell>
                <TableCell className='tableCell'>
                    <div style= {{padding:'5px', width:'30px', borderRadius:'5px', backgroundColor:'lightgray', color:'#666', borderWidth:'0.5px', justifyContent:'center'  }}>
                       <Link to={`/outlets/${row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>
                    </div>
               </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default UserSubscriptionTable